import '../../styles/Information.css';

export const InformationTwo = ({ project }) => {
    return (
        <section className="sl-information-section">
            <div className="sl-information-container sl-information-column-gap-default">
                <div className="sl-information-small-container">
                    <div className="sl-information-widget-wrap sl-information-element-populated">
                        <div className="sl-information-widget-container">
                            <h3 className="sl-information-heading-subtitle">
                                Procedimentos Realizados na Unidade
                            </h3>
                        </div>
                        <div className="sl-information-widget-container">
                            <ul className="sl-information-ul">
                                {project.procedures.length > 0 &&
                                    project.procedures.map((procedure) => (
                                        <li>{procedure.service}</li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="sl-information-small-container">
                    <div className="sl-information-widget-wrap sl-information-element-populated">
                        <div className="sl-information-widget-container">
                            <h3 className="sl-information-heading-subtitle">
                                Serviços Oferecidos
                            </h3>
                        </div>
                        <div className="sl-information-widget-container">
                            <ul className="sl-information-ul">
                                {project.services.length > 0 &&
                                    project.services.map((service) => (
                                        <li key={service.service}>{service.service}</li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
